var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetting({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:virtual-meeting"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.5039 7.30469C14.7691 7.30469 15.0235 7.41004 15.211 7.59758C15.3985 7.78512 15.5039 8.03947 15.5039 8.30469V13.3047C15.5039 13.8597 15.0589 14.3047 14.5039 14.3047H16.5039V15.3047H4.50391V14.3047H6.50391C6.23869 14.3047 5.98434 14.1993 5.7968 14.0118C5.60926 13.8243 5.50391 13.5699 5.50391 13.3047V8.30469C5.50391 7.74969 5.94891 7.30469 6.50391 7.30469H14.5039ZM14.5039 8.30469H6.50391V13.3047H14.5039V8.30469ZM10.5039 11.3047C11.6089 11.3047 12.5039 11.7547 12.5039 12.3047V12.8047H8.50391V12.3047C8.50391 11.7547 9.39891 11.3047 10.5039 11.3047ZM10.5039 8.80469C10.7691 8.80469 11.0235 8.91004 11.211 9.09758C11.3985 9.28512 11.5039 9.53947 11.5039 9.80469C11.5039 10.0699 11.3985 10.3243 11.211 10.5118C11.0235 10.6993 10.7691 10.8047 10.5039 10.8047C9.94891 10.8047 9.50391 10.3597 9.50391 9.80469C9.50391 9.24969 9.95391 8.80469 10.5039 8.80469Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetting);
export default __webpack_public_path__ + "static/media/metting.ca729fbd0fa9f45c8bff93f63057e6c6.svg";
export { ForwardRef as ReactComponent };